import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="mintdeals navbar navbar-expand-lg navbar-light bg-mintdeals">
      <div className="container-fluid">
        <Link className="navbar-brand text-white" to="/">MintDeals</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item"><Link className="nav-link text-white" to="/explore">Explore Clubs</Link></li>
            <li className="nav-item"><Link className="nav-link text-white" to="/explore/myclubs">My Clubs</Link></li>
            <li className="nav-item"><Link className="nav-link text-white" to="/dashboard/club">Dashboard</Link></li>
            <li className="nav-item"><Link className="nav-link text-white" to="/">Logout</Link></li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
